import React from 'react';

const ProposalContext = React.createContext();

export default ProposalContext;
